import {TypeSafeForm} from "@boma/shared/entities";
import {ICustomerLocationProductPricingRequest} from "@boma/supplier-portal/shared/entities";
import {FormBuilder} from "@angular/forms";
import {Nullable} from "../nullable";

export class ProductLocationPricingTierFormFields {
  id: Nullable<string> = null;
  productId: Nullable<string> = null;
  locationId: Nullable<string> = null;
  price: Nullable<number> = null;
  minimumOrderQuantity = 1;
  specialInstructions = '';
  acceptCashOnDelivery = false;
  acceptBankTransfers = false;
  maximumOrderQuantity: Nullable<number> = null;
  enforceStockChecks = false;
  confirmAllOrders = false;
  validUntil = '';
  validFrom = '';

  constructor(obj?: Partial<ProductLocationPricingTierFormFields>) {
    if (obj) Object.assign(this, obj);
  }
}

export class LocationProductPricingForm extends TypeSafeForm<ICustomerLocationProductPricingRequest>{
  constructor(fb: FormBuilder, initial: Partial<ICustomerLocationProductPricingRequest>) {
    super(fb, initial);
  }
}

export class CreatePricingGroupFormFields {
  id?: string | null = null;
  name: string = null;
  entityId: string = null;
  customerIds: string[] = null;
  pricing: { [productId: string]: ProductLocationPricingTierFormFields } = null;

  constructor() {}
}

export class CreatePricingGroupPricingForm extends TypeSafeForm<
  CreatePricingGroupFormFields
  > {
  constructor(
    private f: FormBuilder,
    private initialValue?: Partial<CreatePricingGroupFormFields>
  ) {
    super(f, { ...new CreatePricingGroupFormFields(), ...initialValue });
  }
}
